const FieldCompletenessIndicatorTestIdsScope = {
  FIELD_COMPLETENESS: 'field-completeness',
};

export const FieldCompletenessIndicatorTestIds = {
  SUPPRESS_BUTTON: `${FieldCompletenessIndicatorTestIdsScope.FIELD_COMPLETENESS}.suppress-button`,
  OVERRIDDEN_LABEL: `${FieldCompletenessIndicatorTestIdsScope.FIELD_COMPLETENESS}.overridden-label`,
};
